module.exports = __webpack_public_path__ + "static/media/dark_cherry.dc51b373.png";